/* eslint-disable jsx-a11y/accessible-emoji */
import React, { useState, useEffect } from "react";
import "./who-am-i.scss";

export default function WhoAmI(props) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  useEffect(() => {
    let user = window.sessionStorage.getItem("user");
    if (user) {
      user = JSON.parse(user);
      setName(user.name);
      setEmail(user.email);
    }
  }, []);

  function updateLocalStorage() {
    const person = {
      name,
      email,
    };
    window.sessionStorage.setItem("user", JSON.stringify(person));
  }

  const onLetMeIn = (evt) => {
    if (name.length > 0 && email.length > 0) {
      updateLocalStorage();
    }
  };

  return (
    <div className="whoami-wrapper">
      <div className="whoami">
        <div className="whoami__header">
          <div className="whoami__header__hand">&#128075;</div>
          <div className="whoami__header__title">Hello, tell us who you're</div>
          <div className="whoami__header__message">
            <em>
              You're joining <strong>Maryann's Notespace</strong>
            </em>
          </div>
        </div>
        <div className="whoami__body">
          <div className="whoami__form">
            <input
              placeholder="Your name please..."
              className="whoami__form__input"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
            <input
              placeholder="Your email, work email is ideal"
              className="whoami__form__input"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            <input
              className="whoami__form__button"
              type="button"
              value="Let me in &#8674;"
              onClick={onLetMeIn}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
